import type { FC } from 'react';
// biome-ignore lint/style/useImportType: legacy import, will be migrated
import * as React from 'react';

type SmallBusinessLogoProps = {
  isSelected?: boolean;
};

const MiddleCommercialLogo: FC<
  React.PropsWithChildren<SmallBusinessLogoProps>
> = ({ isSelected }) => {
  return (
    <svg
      viewBox="0 0 170 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="fill-current transition-all"
      css={`
        color: ${isSelected ? 'var(--color-primary-light-400)' : '#b7bad5'};
        width: 98px;
        height: fit-content;

        @media (min-width: 768px) {
          width: 159px;
        }
        @media (min-width: 1024px) {
          width: 170px;
        }
      `}
    >
      <g
        clipPath="url(#a)"
        stroke="#33344F"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M136 16H42v87h94V16Z" fill="#fff" />
        <path d="M129 70H79v9h50v-9Z" fill="null" />
        <path d="M72 16v87M85 79v24M123 79v24" />
        <path d="M129 28H80v29h49V28ZM142 16H37V4.868L142 0v16Z" fill="null" />
        <path d="M110 28 85 48M128 41l-13 10M112 34 85 57" />
        <path
          d="M47 66.51c0-5.253-4.253-9.51-9.5-9.51S28 61.257 28 66.51v16.98c0 5.253 4.253 9.51 9.5 9.51s9.5-4.257 9.5-9.51V66.51Z"
          fill="null"
        />
        <path d="M38 93v10" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h170v102H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MiddleCommercialLogo;
